import { render, staticRenderFns } from "./ManualSubmissionTable.vue?vue&type=template&id=d73c8674"
import script from "./ManualSubmissionTable.vue?vue&type=script&lang=ts"
export * from "./ManualSubmissionTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports